export default __webpack_public_path__ + "static/media/PSR3.2eae1168.JPEG";